export const UPDATE_STATS = 'PN UPDATE STATS';
export const SET_OPTIONS = 'PN SET OPTIONS';
export const SET_OPTION = 'PN SET OPTION';
export const SET_MODE = 'PN SET MODE';
export const SET_SKILL = 'PN SET SKILL';
export const SELECT_SIZE = 'PN SELECT SIZE';
export const SET_BLOCK = 'PN SET BLOCK';
export const SET_OVER = 'PN SET OVER';
export const SET_OVER_TRUE = { type: SET_OVER, over: true };
export const SET_OVER_FALSE = { type: SET_OVER, over: false };
export const SELECT_TILE = 'PN SELECT TILE';
export const UNSELECT_TILE = { type: SELECT_TILE, selected: null };
export const UPDATE_IN_PILE_COUNT = 'PN UPDATE IN-PILE COUNT';
export const SET_MAX_PAIRS = 'PN SET MAX PAIRS';
export const SET_PAIRS = 'PN SET PAIRS';
export const SET_SCORE = 'PN SET SCORE';
export const SET_MAX_SCORE = 'PN SET MAX SCORE';
export const SET_OPP_PAIRS = 'PN SET OPP PAIRS';
export const REPORT_INVALID_ACTION = 'PN REPORT INVALID ACTION';
export const UNREPORT_INVALID_ACTION = { type: REPORT_INVALID_ACTION, message: null };
export const SET_TURN = 'PN SET TURN';
export const SET_STARTED = 'PT SET STARTED';
export const SET_STARTED_TRUE = { type: SET_STARTED, started: true };
export const SET_STARTED_FALSE = { type: SET_STARTED, started: false };
export const SHOW_PILE = 'SHOW PILE';
export const HIDE_PILE = { type: SHOW_PILE, show: false };
